import React, { useState } from "react";
import OrderProductTable from "./OrderProductTable";

interface Product {
    id: number;
    order_id: number;
    discount_price: number | null;
    status: number | null;
    quantity_product: number;
    actual_quantity?: number;
    name_product: string;
    slug_product: string;
    avatar_product: string;
    price_product: number;
}

interface RedeemedGift {
    id: number;
    order_id: number;
    gift_id: number;
    name: string;
    avatar: string;
    point: number;
    status: 'PENDING' | 'DONE' | 'CANCELLED' | string;
    product?: {
        avatar: string;
        id: number;
        name: string;
        slug: string;
    }
}

interface MyOrderDetailListProductProps {
    products: Product[];
    redeemedGifts?: RedeemedGift[];
    subtotal?: number;
    discount?: number;
    pricing?: {
        original_items_amount?: number;
        total_discount?: number;
        final_items_amount?: number;
        final_total_amount?: number;
        actual_original_amount?: number;
        actual_total_discount?: number;
        actual_final_amount?: number;
        point_earned?: number;
        voucher_breakdown?: Array<{
            code: string;
            template_name: string;
            discount_applied: number;
            applied_to: string;
            type: string;
        }>;
    };
    total_point?: number;
    actual_final_amount?: number;
    total: number;
    orderStatus?: string;
}

export default function MyOrderDetailListProduct({ products, redeemedGifts = [], pricing, subtotal = 0, discount = 0, total_point = 0, actual_final_amount, total, orderStatus }: MyOrderDetailListProductProps) {
    const displayTotal = actual_final_amount ?? total;
    const hasActualTotal = typeof actual_final_amount === "number";
    const pointEarned = pricing?.point_earned ?? total_point;
    return (
        <div className="MuiGrid-root styles_table_wrapper__bJ_CM MuiGrid-item MuiGrid-grid-xs-12">
            <div className="MuiGrid-root styles_table__2_Acb MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12">
                <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-content-xs-space-between MuiGrid-grid-xs-12">
                    <p className="styles_title_list__67DiS">Danh sách sản phẩm ({products.length} sản phẩm)</p>
                </div>
                <OrderProductTable products={products} orderStatus={orderStatus} />
                <div className="MuiGrid-root styles_dashed__CDiXX styles_bottomListProduct__p4Gnw MuiGrid-item MuiGrid-grid-xs-12"></div>

                {redeemedGifts.length > 0 && (
                    <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12" style={{ marginTop: "16px" }}>
                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12" style={{ marginBottom: "8px" }}>
                            <p className="styles_title_list__67DiS">Quà đã đổi ({redeemedGifts.length} quà)</p>
                        </div>
                        {redeemedGifts.map((gift) => (
                            gift.product ? (
                                <a
                                    href={`/product/${gift.product.slug}`}
                                    key={gift.id} className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12" style={{ padding: "8px 0", borderBottom: "1px dashed #ececec" }}>
                                    {
                                        gift.product.avatar && gift.product.avatar != "" ? (
                                            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-2 styles_imgProduct__F3j0T" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <img src={gift.product?.avatar || gift.avatar} alt={gift.product?.name || gift.name} style={{
                                                    width: "60px",
                                                    height: "60px",
                                                    borderRadius: "4px",
                                                    objectFit: "cover",
                                                    border: "1px solid #ececec"
                                                }} />
                                            </div>
                                        ) : (
                                            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-2 styles_imgProduct__F3j0T" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <div style={{
                                                    width: "60px",
                                                    height: "60px",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#f0f0f0"
                                                }} />
                                            </div>
                                        )}
                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-8">
                                        <p className="MuiTypography-root MuiTypography-body1">{gift.product?.name || gift.name}</p>
                                    </div>
                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-2" style={{ textAlign: "right" }}>
                                        <p className="MuiTypography-root MuiTypography-body1">{gift.point.toLocaleString()} điểm</p>
                                    </div>
                                </a>
                            ) : (
                                <div key={gift.id} className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12" style={{ padding: "8px 0", borderBottom: "1px dashed #ececec" }}>
                                    {
                                        gift.avatar && gift.avatar != "" ? (
                                            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-2 styles_imgProduct__F3j0T" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <img src={gift.avatar} alt={gift.name} style={{
                                                    width: "60px",
                                                    height: "60px",
                                                    borderRadius: "4px",
                                                    objectFit: "cover",
                                                    border: "1px solid #ececec"
                                                }}
                                                />
                                            </div>
                                        ) : (
                                            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-2 styles_imgProduct__F3j0T" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                <div style={{
                                                    width: "60px",
                                                    height: "60px",
                                                    borderRadius: "4px",
                                                    backgroundColor: "#f0f0f0",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    border: "1px solid #ececec",
                                                    color: "#999",
                                                    fontSize: "12px",
                                                    textAlign: "center",
                                                    padding: "4px"
                                                }}>
                                                    No Image
                                                </div>
                                            </div>
                                        )
                                    }
                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-8">
                                        <p className="MuiTypography-root MuiTypography-body1">{gift.name}</p>
                                    </div>
                                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-2" style={{ textAlign: "right" }}>
                                        <p className="MuiTypography-root MuiTypography-body1">{gift.point.toLocaleString()} điểm</p>
                                    </div>
                                </div>
                            )
                        ))}
                    </div>
                )}

                {/* total */}
                <div
                    className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12"
                    style={{ marginTop: "20px" }}
                >
                    <div className="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-12">
                        <div className="MuiGrid-root styles_bottomPrice__C9gx6 MuiGrid-item MuiGrid-grid-xs-10">
                            <p className="MuiTypography-root MuiTypography-body1">Tổng giá sản phẩm</p>
                        </div>
                        <div className="MuiGrid-root styles_bottomPriceRight__PgCQH MuiGrid-item MuiGrid-grid-xs-2">
                            <p className="MuiTypography-root MuiTypography-body1">{pricing?.actual_original_amount?.toLocaleString()}đ</p>
                        </div>

                        <div className="MuiGrid-root styles_bottomPrice__C9gx6 MuiGrid-item MuiGrid-grid-xs-10">
                            <p className="MuiTypography-root MuiTypography-body1">Tổng giảm giá</p>
                        </div>
                        <div className="MuiGrid-root styles_bottomPriceRight__PgCQH MuiGrid-item MuiGrid-grid-xs-2">
                            <p className="MuiTypography-root MuiTypography-body1">-{pricing?.actual_total_discount?.toLocaleString()}đ</p>
                        </div>

                        <div className="MuiGrid-root styles_bottomPrice__C9gx6 MuiGrid-item MuiGrid-grid-xs-10">
                            <p className="MuiTypography-root MuiTypography-body1">Tiền khách đặt</p>
                        </div>
                        <div className="MuiGrid-root styles_bottomPriceRight__PgCQH MuiGrid-item MuiGrid-grid-xs-2">
                            <p className="MuiTypography-root MuiTypography-body1">{(pricing?.final_total_amount ?? total)?.toLocaleString()}đ</p>
                        </div>

                        <div className="MuiGrid-root styles_bottomPrice__C9gx6 MuiGrid-item MuiGrid-grid-xs-10">
                            <p className="MuiTypography-root MuiTypography-body1">Tiền thực tế</p>
                        </div>
                        <div className="MuiGrid-root styles_bottomPriceRight__PgCQH MuiGrid-item MuiGrid-grid-xs-2">
                            <p className="MuiTypography-root MuiTypography-body1">{(pricing?.actual_final_amount ?? total)?.toLocaleString()}đ</p>
                        </div>

                        {pointEarned > 0 && (
                            <>
                                <div className="MuiGrid-root styles_bottomPrice__C9gx6 MuiGrid-item MuiGrid-grid-xs-10">
                                    <p className="MuiTypography-root MuiTypography-body1" style={{ color: '#e88438', fontWeight: 600 }}>Điểm tích lũy</p>
                                </div>
                                <div className="MuiGrid-root styles_bottomPriceRight__PgCQH MuiGrid-item MuiGrid-grid-xs-2">
                                    <p className="MuiTypography-root MuiTypography-body1" style={{ color: '#e88438', fontWeight: 600 }}>+{pointEarned.toLocaleString()}</p>
                                </div>
                            </>
                        )}

                    </div>

                    <div className="MuiGrid-root styles_dashed__CDiXX MuiGrid-item MuiGrid-grid-xs-12" />

                    <div className="MuiGrid-root styles_totalPrice__wNFOG MuiGrid-container MuiGrid-item MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-space-between MuiGrid-grid-xs-12">
                        <div className="MuiGrid-root styles_price_label__aj6A0 MuiGrid-item">
                            <p className="MuiTypography-root MuiTypography-body1" style={{ fontSize: '18px', fontWeight: 700 }}>Tổng tiền thanh toán</p>
                        </div>
                        <div className="MuiGrid-root styles_price___bg9n MuiGrid-item">
                            <p className="MuiTypography-root MuiTypography-body1" style={{ fontSize: '20px', fontWeight: 700, color: '#d4323b' }}>{pricing?.actual_final_amount?.toLocaleString()}đ</p>
                        </div>
                    </div>

                    <div className="MuiGrid-root styles_groupActionBtn__7_FZq MuiGrid-container MuiGrid-item MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-center MuiGrid-grid-xs-12">
                        <div className="MuiGrid-root styles_disableBtn__AXJMP MuiGrid-container MuiGrid-item MuiGrid-justify-content-xs-center MuiGrid-grid-sm-4">
                            <button
                                className="MuiButtonBase-root MuiButton-root MuiButton-text jss197 jss200 styles_btnRequestCancel__TYfBm styles_disableBtn__AXJMP Mui-disabled Mui-disabled"
                                tabIndex={-1}
                                type="button"
                                disabled
                            >
                                <span className="MuiButton-label">Yêu cầu hủy đơn</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
